import { apiPost } from "../baseApi";

export const uploadLogo = async (data, id) => {
  try {
    const response = await apiPost("_districtUploadLogo", data, id);
    return response;
  } catch (error) {
    return Promise.reject(error);
  }
};
